import { createVNode as r, mergeProps as n } from "vue";
import f from "../node_modules/@pf-ui/pf-icon-svg/es/asn/StaffFemaleTwotoneStandard.js";
import m from "../components/PfIcon.js";
const t = (e, a) => {
  const o = {
    ...e,
    ...a.attrs
  };
  return r(m, n(o, {
    icon: f
  }), null);
};
t.displayName = "StaffFemaleTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
